<script setup>
import { ref, watch } from "vue";
import MessagesSidebar from "@/components/messages/MessagesSidebar.vue";
import TasksFeed from "@/components/tasks/TasksFeed.vue";
import { useAuthStore } from "@/stores/auth.js";
import Default from "@/layouts/default.vue";
import EmployeeStat from "@/components/employee/EmployeeStat.vue";
import employeeApi from "@/api/employeeApi.js";

const auth = useAuthStore();
const employeeStat = ref(null);

watch(
  () => auth.me?.id,
  async (id) => {
    if (!id) {
      employeeStat.value = null;
      return;
    }
    try {
      employeeStat.value = await employeeApi.getEmployee(id);
    } catch (e) {
      console.error("Ошибка загрузки статистики сотрудника:", e);
      employeeStat.value = null;
    }
  },
  { immediate: true }
);
</script>

<template>
  <Default>
    <!-- Обёртка под слот: растягиваемся и позволяем скролл внутри колонок -->
    <div class="flex-1 min-h-0 flex">
      <div class="flex gap-4 w-full h-full min-h-0">
        <div class="w-1/2 min-h-0 flex flex-col gap-4">
          <EmployeeStat v-if="employeeStat" :employee="employeeStat" class="flex-shrink-0" />
          <MessagesSidebar class="flex-1 min-h-0" />
        </div>
        <div class="w-1/2 min-h-0">
          <TasksFeed />
        </div>
      </div>
    </div>
  </Default>

</template>



<style scoped>
</style>
